import React from "react";
import CommunityAddPage from "../community/components/CommunityAddPage";
import { SHARE_WITH_NEIGHBORS } from "../community/constants";

export default function AddShareWithNeighborsPage() {
  return <CommunityAddPage section={SHARE_WITH_NEIGHBORS} />;
}
